<div
  class="co-property d-flex align-items-center gap-2"
  [class.co-property-clickable]="property && clickable"
  (click)="onOpen($event)"
>
  <img
    class="co-property-cover rounded flex-shrink-0"
    [src]="imageUrl"
    alt=""
    (error)="onImageError($event)"
  />

  <div class="flex-grow-1 min-w-0">
    <ng-container *ngIf="property; else external">
      <p class="mb-0 fs-13 fw-semibold text-truncate co-property-title">
        {{ property.title || property.reference || "—" }}
      </p>
      <div class="d-flex align-items-center gap-2 flex-wrap fs-12 text-muted">
        <span *ngIf="property.reference" class="badge badge-soft-secondary fs-11 fw-medium">
          <i class="ri-hashtag"></i>{{ property.reference }}
        </span>
        <span *ngIf="property.price" class="co-property-price">
          {{ property.price | currency: "EUR" : "symbol" : "1.0-0" }}
        </span>
      </div>
    </ng-container>

    <ng-template #external>
      <p class="mb-0 fs-13 fw-semibold text-truncate">
        {{ externalReference || ("t-contact-overview.t-no-property" | translate) }}
      </p>
      <span *ngIf="externalReference" class="badge badge-soft-warning fs-11">
        {{ "t-deals-detail-external-property" | translate }}
      </span>
    </ng-template>
  </div>
</div>
